import { memo } from "react";
import { Avatar, isWeb, LoadingButton, Paragraph, Paragraph2, ParagraphSmall, XStack, YStack } from "@medbillai/ui";
import type { Endpoint } from "../../../lib/accounts-link/types";
import { getLogoLetter, getLogoSlug } from "../../../lib/accounts-link/utils";
import { imageAssets } from "../../../logo-assets/logo-manifest/manifest";
import { resultUnavailableKey } from "../utils/utils";
import { AccountLogo } from "./AccountLogo";
type AccountLinkEndpointProps = {
  endpoint: Endpoint;
  onClick: () => void;
};
export const AccountLinkEndpoint = memo(({
  endpoint,
  onClick
}: AccountLinkEndpointProps) => {
  const name = endpoint?.displayName || "Unknown";
  const endpointSlug = getLogoSlug(endpoint);
  const endpointLetter = getLogoLetter(endpoint);
  const logoAsset = imageAssets[endpointSlug];
  const logoImage = `/static/logos/${endpointSlug}.png`;
  const hasLogo = logoAsset != null;
  const subtitle = endpoint.displayUrl;
  const resultUnavailable = endpoint.displayName === resultUnavailableKey;
  return <YStack width="100%">
        {resultUnavailable ? <AccountLinkRequestButton onClick={onClick} /> : <XStack gap="$3" ai="center" width="100%" py="$2" onPress={onClick} backgroundColor="$surface1"
    // TODO: this animation is possibly causing performance issue when the
    // list is being filtered. Only appears on devices, not in the emulator.
    // transition="quick"
    pressStyle={{
      backgroundColor: "$surface1Hover"
    }} hoverStyle={{
      backgroundColor: "$surface1Hover"
    }}>
            <XStack px="$5" ai="center" gap="$3">
              {isWeb ? <Avatar image={hasLogo ? logoImage : undefined} initials={endpointLetter} width={43} height={43} borderRadius="$12" borderColor="transparent" objectFit="contain" /> : <AccountLogo endpoint={endpoint} style={{
          br: "$12",
          backgroundColor: "$surface1",
          borderColor: "transparent"
        }} />}
              <YStack height={50} alignItems="flex-start" jc="center" f={1}>
                <Paragraph numberOfLines={1} overflow="hidden" textOverflow="ellipsis">
                  {name}
                </Paragraph>
                {subtitle ? <Paragraph2 theme="alt1" numberOfLines={1} overflow="hidden" textOverflow="ellipsis">
                    {subtitle}
                  </Paragraph2> : null}
              </YStack>
            </XStack>
          </XStack>}
      </YStack>;
});
AccountLinkEndpoint.displayName = "AccountLinkEndpoint";
interface AccountLinkRequestButtonProps {
  onClick: () => void;
}
const AccountLinkRequestButton = ({
  onClick
}: AccountLinkRequestButtonProps) => {
  return <XStack gap="$3" ai="center" px="$4.5" py="$2" width="100%" br="$3" jc="space-between" data-sentry-element="XStack" data-sentry-component="AccountLinkRequestButton" data-sentry-source-file="AccountLinkEndpoint.tsx">
      <YStack gap="$1" jc="center" height={50} alignItems="flex-start" data-sentry-element="YStack" data-sentry-source-file="AccountLinkEndpoint.tsx">
        <ParagraphSmall bold data-sentry-element="ParagraphSmall" data-sentry-source-file="AccountLinkEndpoint.tsx">Can&apos;t find your insurance?</ParagraphSmall>
        <ParagraphSmall bold theme="alt1" data-sentry-element="ParagraphSmall" data-sentry-source-file="AccountLinkEndpoint.tsx">
          Request it here
        </ParagraphSmall>
      </YStack>
      <LoadingButton width="$12" height="$4" onPress={onClick} data-sentry-element="LoadingButton" data-sentry-source-file="AccountLinkEndpoint.tsx">
        Request
      </LoadingButton>
    </XStack>;
};